import { createContext } from 'react';

const SignupContext =  createContext();

export default SignupContext;